"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenBody = void 0;
const bit_array_1 = require("./bit.array");
class TokenBody {
    constructor(body) {
        this.issuer = body.issuer;
        this.version = body.version;
        this.expiration = body.expiration;
        this.issuedAt = body.issuedAt;
        this.user = body.user;
        this.projects = body.projects;
    }
    static loadFromToken(jwtToken) {
        const body = this.getBody(jwtToken);
        const bodyData = {
            issuer: body.iss,
            version: body.version,
            expiration: new Date(body.exp * 1000),
            issuedAt: new Date(body.iat * 1000),
            user: body.user,
            projects: bit_array_1.BitArray.fromBase64(body.user.projects),
            accounts: body.accounts,
        };
        return new TokenBody(bodyData);
    }
    getProjects() {
        return [...this.projects.all()];
    }
    hasProject(projectId) {
        return this.projects.get(projectId);
    }
    static getBody(jwtToken) {
        if (!jwtToken) {
            return null;
        }
        const values = jwtToken.split('.');
        if (values.length !== 3) {
            return null;
        }
        return this.toJson(values[1]);
    }
    static toJson(base64) {
        return JSON.parse(this.decodeBase64(base64));
    }
    static decodeBase64(base64) {
        base64 = base64.replace(/\-/g, '+').replace(/\_/g, '/');
        if (typeof Buffer !== 'undefined') {
            return Buffer.from(base64, 'base64').toString('utf-8');
        }
        else {
            return atob(base64);
        }
    }
}
exports.TokenBody = TokenBody;
//# sourceMappingURL=token.body.js.map